var VideoWidget = /** @class */ (function () {
    function VideoWidget(widget) {
        this.widget = widget;
        this.init();
    }
    VideoWidget.prototype.init = function () {
        // Initialize video widget functionality
        this.setupVideoOverlays();
    };
    VideoWidget.prototype.setupVideoOverlays = function () {
        var _this = this;
        var overlays = this.widget.querySelectorAll('.rmff-video-overlay');
        overlays.forEach(function (overlay) {
            overlay.addEventListener('click', function (e) {
                e.preventDefault();
                _this.handleOverlayClick(overlay);
            });
        });
    };
    VideoWidget.prototype.handleOverlayClick = function (overlay) {
        var videoType = overlay.getAttribute('data-video-type');
        var videoUrl = overlay.getAttribute('data-video-url');
        if (videoType === 'upload') {
            this.playUploadedVideo(overlay);
        }
        else if (videoType === 'youtube' || videoType === 'vimeo') {
            this.playEmbeddedVideo(overlay, videoUrl, videoType);
        }
    };
    VideoWidget.prototype.playUploadedVideo = function (overlay) {
        var _a;
        var video = (_a = overlay.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.rmff-video-player');
        if (video) {
            video.play();
            overlay.style.display = 'none';
        }
    };
    VideoWidget.prototype.playEmbeddedVideo = function (overlay, videoUrl, videoType) {
        var _a, _b, _c;
        if (!videoUrl)
            return;
        var embedContainer = (_a = overlay.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.rmff-video-embed');
        if (!embedContainer)
            return;
        var iframe = embedContainer.querySelector('iframe');
        if (!iframe)
            return;
        // Hide overlay immediately
        overlay.style.display = 'none';
        if (videoType === 'youtube') {
            // Use postMessage to play YouTube video via iframe API
            (_b = iframe.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        else if (videoType === 'vimeo') {
            // Use postMessage to play Vimeo video
            (_c = iframe.contentWindow) === null || _c === void 0 ? void 0 : _c.postMessage('{"method":"play"}', '*');
        }
    };
    VideoWidget.prototype.extractYouTubeId = function (url) {
        var regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
        var match = url.match(regex);
        return match ? match[1] : null;
    };
    VideoWidget.prototype.extractVimeoId = function (url) {
        var regex = /vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)/;
        var match = url.match(regex);
        return match ? match[1] : null;
    };
    return VideoWidget;
}());
// Initialize video widgets when DOM is ready
export function initVideoWidgets() {
    var videoWidgets = document.querySelectorAll('.rmff-video-widget');
    videoWidgets.forEach(function (widget) {
        new VideoWidget(widget);
    });
}
// Export for use in main index.ts
window.VideoWidget = VideoWidget;
window.initVideoWidgets = initVideoWidgets;
